/*
  Batch-insert translation keys and values into your
  i18n locale files (en.js, tr.js, etc.) in alphabetic order.

  Usage:
    1. Create a JSON file `newTranslations.json` next to this script:
       {
         "en": { "key1": "value1", … },
         "tr": { "key1": "value1", … }
       }
    2. Run:
       node update-i18n.js
*/

const fs = require("fs");
const path = require("path");
const prettier = require("prettier");

const I18N_DIR = __dirname;
const NEW_TRANSLATIONS_FILE = path.join(I18N_DIR, "newTranslations.json");

function mergeAndSort(base, additions) {
	const result = { ...base };
	for (const [key, value] of Object.entries(additions)) {
		if (
			value &&
			typeof value === "object" &&
			!Array.isArray(value) &&
			key in result &&
			typeof result[key] === "object"
		) {
			result[key] = mergeAndSort(result[key], value);
		} else {
			result[key] = value;
		}
	}
	return Object.keys(result)
		.sort((a, b) => a.localeCompare(b))
		.reduce((obj, k) => {
			obj[k] = result[k];
			return obj;
		}, {});
}

(async function () {
	if (!fs.existsSync(NEW_TRANSLATIONS_FILE)) {
		console.error("❌ Missing newTranslations.json in", I18N_DIR);
		process.exit(1);
	}
	const newTrans = JSON.parse(fs.readFileSync(NEW_TRANSLATIONS_FILE, "utf8"));

	const localeFiles = fs.readdirSync(I18N_DIR).filter((f) => /^[a-z]{2}\.js$/.test(f));

	for (const file of localeFiles) {
		const lang = path.basename(file, ".js");
		const additions = newTrans[lang];
		if (!additions) {
			console.log(`⚠️  No new translations for '${lang}', skipping.`);
			continue;
		}

		const filePath = path.join(I18N_DIR, file);
		const content = fs.readFileSync(filePath, "utf8");
		const match = content.match(/export\s+default\s+(\{[\s\S]*\})(;?)/m);
		if (!match) {
			console.error(`❌ Could not parse '${file}', skipping.`);
			continue;
		}

		const existing = eval("(" + match[1] + ")");
		const merged = mergeAndSort(existing, additions);
		const exportBlock = `export default ${JSON.stringify(merged, null, 2)};`;
		const prettierConfig = (await prettier.resolveConfig(filePath)) || {};
		prettierConfig.parser = "babel";
		const output = prettier.format(exportBlock, prettierConfig);
		fs.writeFileSync(filePath, output, "utf8");
		console.log(`✅ Updated ${file}`);
	}
	console.log("🎉 All locale files updated.");
})();
